// extracted by mini-css-extract-plugin
module.exports = {"detail-btn":"DetailBtn_detail-btn__3ya80","detail-btn-txt":"DetailBtn_detail-btn-txt__181r2","detail-btn-icon":"DetailBtn_detail-btn-icon___8yYE"};